import React from "react";
import {NodeViewContent, NodeViewWrapper} from "@tiptap/react";
import type {NodeViewProps} from "@tiptap/react";
import {
    getPrintoutRegionKind,
    PRINTOUT_REGION_ATTRIBUTE,
    PRINTOUT_REGION_CLASS,
    PRINTOUT_REGION_CONTENT_CLASS,
} from "./printoutRegionOptions";

// Every enabled region repeats; pagination only needs its kind.
const PrintoutRegionNodeView = (props: NodeViewProps) => {
    const kind = getPrintoutRegionKind(props.node.type.name) ?? "header";

    return (
        <NodeViewWrapper
            as="div"
            className={`${PRINTOUT_REGION_CLASS} ${PRINTOUT_REGION_CLASS}--${kind}`}
            {...{
                [PRINTOUT_REGION_ATTRIBUTE]: kind,
            }}
        >
            <NodeViewContent as="div" className={PRINTOUT_REGION_CONTENT_CLASS}/>
        </NodeViewWrapper>
    );
};

export default PrintoutRegionNodeView;
